import { createTenantManagementRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';

const request = createTenantManagementRequest();

export interface AuthorizedResourceAction {
  name: string;
  description?: string;
}

export interface AuthorizedResource {
  effect?: string;
  code: string;
  type?: string;
  condition?: unknown;
  description?: string | null;
  actions?: Array<string | AuthorizedResourceAction>;
  apiIdentifier?: string | null;
  namespaceId?: number | null;
}

export async function getMyAuthorizedResources(
  appId: string,
  options?: ApiRequestOptions,
) {
  const response = await request<
    | AuthorizedResource[]
    | {
        success?: boolean;
        data?: AuthorizedResource[];
        list?: AuthorizedResource[];
      }
  >('/bff/permission/me/authorized-resources', {
    method: 'GET',
    params: { appId },
    ...(options || {}),
  });

  if (Array.isArray(response)) {
    return response;
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  if (Array.isArray(response?.list)) {
    return response.list;
  }

  throw new Error('Unsupported authorized-resources response');
}
